import { Component, Input, OnChanges } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { pathToApp } from '../../../core/constants/global-constants';

@Component({
    selector: 'progressBarComponent',
    templateUrl: pathToApp + 'shared/components/progress-bar/progress-bar.component.html',
})
export class ProgressBarComponent implements OnChanges {
    @Input() showPercentage: boolean;
    @Input() status: string;
    @Input() progress: number = 0;
    @Input() fullWidth: boolean;

    ngOnChanges() {
        if (this.progress === null || isNaN(this.progress)) {
            this.progress = 0; 
        }
    }
}
angular.module('omc').directive(
    'progressBarComponent',
    downgradeComponent({
        component: ProgressBarComponent,
        inputs: ['showPercentage', 'status', 'progress', 'fullWidth'],
    })
)
